import { z } from 'zod';

export const SiteSchema = z.enum(['aar', 'fra']);
export type Site = z.infer<typeof SiteSchema>;
